export default __webpack_public_path__ + "static/media/about.4fe54bc2.png";